import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon as IconChakra,
  Input as ChakraInput,
  InputGroup,
  InputLeftElement,
  InputProps as ChakraInputProps,
} from "@chakra-ui/react";
import React, { forwardRef, ForwardRefRenderFunction } from "react";
import { FieldError } from "react-hook-form";
import { IconBaseProps } from "react-icons";

interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  icon: React.ComponentType<IconBaseProps>;
  error?: FieldError;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { name, label, icon: Icon, error = null, ...rest },
  ref
) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel color="white" htmlFor={name}>
          {label}
        </FormLabel>
      )}
      <InputGroup>
        <InputLeftElement
          children={<IconChakra as={Icon} w="4" h="4" color="gray" />}
        />
        <ChakraInput
          id={name}
          name={name}
          focusBorderColor="green_primary"
          bg="white"
          _hover={{
            bg: "white",
          }}
          size="lg"
          ref={ref}
          {...rest}
        />
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const Input = forwardRef(InputBase);
